import { useState, type FormEvent } from 'react';
import { useAuth } from '../lib/auth';
import { supabase } from '../lib/supabase';

export default function Account() {
  const { profile, session } = useAuth();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [msg, setMsg] = useState<{ kind: 'ok' | 'error'; text: string } | null>(null);
  const [busy, setBusy] = useState(false);

  const save = async (e: FormEvent) => {
    e.preventDefault();
    if (pw.length < 10) return setMsg({ kind: 'error', text: 'Use at least 10 characters.' });
    if (pw !== pw2) return setMsg({ kind: 'error', text: 'The two passwords don’t match.' });
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password: pw });
    setBusy(false);
    setPw('');
    setPw2('');
    setMsg(error ? { kind: 'error', text: error.message } : { kind: 'ok', text: 'Password saved.' });
  };

  return (
    <div className="page" style={{ maxWidth: 520 }}>
      <div className="page-head">
        <h1>Account</h1>
      </div>
      <div className="card card-pad stack">
        <div>
          <div><b>{profile?.full_name}</b> <span className="tag">{profile?.role}</span></div>
          <div className="muted">{session?.user.email}</div>
        </div>
        <form className="stack" onSubmit={save}>
          <h3>Set or change password</h3>
          <label className="field">
            <span>New password</span>
            <input type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} />
          </label>
          <label className="field">
            <span>Repeat new password</span>
            <input type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} />
          </label>
          {msg && <div className={msg.kind}>{msg.text}</div>}
          <button className="primary" disabled={busy || !pw}>Save password</button>
        </form>
      </div>
    </div>
  );
}
